<template>
  <vk-modal v-if="showModal" @close="close()">
    <div slot="header"></div>
    <div slot="content" class="d-flex fd-column flex-center">
      <div class="m-x-2 m-x-6:t text-center">
        <div>
          We need additional information to complete your project request.
          Please contact our support team to continue with your request.
        </div>
        <div>
          <a href="tel:1-855-723-2266">
            1-855-723-2266
          </a> or email us at
          <a href="mailto:support@ProReferral.com">
            support@ProReferral.com
          </a>
        </div>
      </div>
      <button
          class="d-block btn m-t-2"
          @click="close()">
        Ok
      </button>
    </div>

  </vk-modal>
</template>
<script>

export default {
  name: 'limit-modal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close () {
      this.$emit('close');
    },
  },
};
</script>
